module.exports = __webpack_public_path__ + "static/media/img_apps_feature_td.2b4d2082.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/App/components/imgs/img_apps_feature_td.svg
// module id = 810
// module chunks = 0